// latest: zhangmyh 2017-11-9 10:44 AM

export default function (params) {
  this.id = params.config.id
  this.fields = params.config.fields.map(function (item) {
    return Object.assign({
      width: 'auto'
    }, item)
  })
  this.rows = params.gridModel[params.config.id]
  this.editable = !!(params.editable)
}



// WEBPACK FOOTER //
// ./src/components/ag-grid/grid/index.js